import styled from '@emotion/styled'
import { colors, typo } from '@mathflat/common/style'

export const S = {
  Modal: styled.div`
    display: flex;
    position: relative;
    width: 860px;
    height: 500px;
  `,
  Left: styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 24px 0;
    border-radius: var(--Radius-200);
    background-color: white;
    .header {
      padding: 0 24px;
      margin-bottom: 22px;
      font-weight: 700;
      color: var(--Colors-Green-600);
      ${typo.heading05};
    }

    .particle {
      position: absolute;
      width: 300px;
      top: 0;
      left: 24px;
    }

    .ql-editor {
      padding: 0;
    }

    .swiper {
      position: relative;
      flex: 1 1 auto;
      overflow: hidden;
      width: 360px;
    }

    .swiper-wrapper {
      display: flex;
      height: 342px;
    }

    .swiper-slide {
      min-width: 360px;
      padding: 0 24px;
      .swiper-title {
        margin-bottom: 16px;
        font-weight: 700;
        ${typo.heading03};
      }

      .swiper-title,
      .swiper-content {
        white-space: pre-wrap;
      }

      .swiper-content {
        ${typo.body01};
      }
    }

    .navigate-wrap {
      display: flex;
      justify-content: flex-end;
      position: absolute;
      padding: 0 24px;
      bottom: 0;
      right: 0;
      left: 0;

      button {
        &:last-of-type {
          margin-left: 8px;
        }
        &.swiper-button-disabled {
          display: none;
        }
      }
    }

    .swiper-pagination {
      position: absolute;
      display: flex;
      align-items: flex-end;
      bottom: 0;
      left: 24px;
      width: 80px;
      height: 40px;

      .swiper-pagination-bullet {
        display: inline-block;
        border-radius: var(--Radius-Circle);
        width: 8px;
        height: 8px;
        background: ${colors.gray.$400};
        &:not(:last-of-type) {
          margin-right: 8px;
        }
      }

      .swiper-pagination-bullet-active {
        background: var(--Colors-Green-500);
      }
    }
  `,
  Right: styled.div`
    border-radius: 0 var(--Radius-100) var(--Radius-100) 0;
    overflow: hidden;
    video {
      width: 500px;
      height: 500px;
    }
  `,
  ButtonWrap: styled.div`
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    transform: translateY(100%);
    z-index: 10000;
    background-color: transparent;

    .close {
      padding-top: 8px;
      padding-left: 10px;
      z-index: 10000;
      color: #fff;
      margin-left: auto;
      ${typo.body01};
    }
  `,
}
